import { CountryCode } from 'root-constants'

export const isUSUser = (countryCode: string): boolean =>
  countryCode.toLowerCase() === CountryCode.UNITED_STATES
